const firebaseConfig = {
    apiKey: "AIzaSyDhhkJUV0IRHRes7y0-Zt4FkYnQ0yogeBU",
    authDomain: "smart-shop-pos.firebaseapp.com",
    projectId: "smart-shop-pos",
    storageBucket: "smart-shop-pos.appspot.com",
    messagingSenderId: "985453297716",
    appId: "1:985453297716:web:efc7b72848301437fd4a61"
};

export default firebaseConfig;